const LAST_LOCATION_KEY = 'lastLocation';

export function isLoginUrl(url: string | null | undefined): boolean {
  if (url == null) {
    return false;
  }

  return url.includes('/login');
}

export function setLastLocation(url: string): void {
  if (!url || isLoginUrl(url)) {
    return;
  }

  const existing = localStorage.getItem(LAST_LOCATION_KEY);
  if (existing != null) {
    console.log('AuthRedirect: lastLocation already set, preserving existing value', existing);
    return;
  }

  console.log('AuthRedirect: setting lastLocation', url);
  localStorage.setItem(LAST_LOCATION_KEY, url);
}

export function getAndClearLastLocation(): string | null {
  const url = localStorage.getItem(LAST_LOCATION_KEY);

  if (url != null) {
    console.log('AuthRedirect: consuming and clearing lastLocation', url);
    localStorage.removeItem(LAST_LOCATION_KEY);
  }

  return url;
}

export function clearLastLocation(): void {
  const existing = localStorage.getItem(LAST_LOCATION_KEY);
  if (existing != null) {
    console.log('AuthRedirect: clearing lastLocation explicitly', existing);
    localStorage.removeItem(LAST_LOCATION_KEY);
  }
}
